export class SSOLink {
  host: string;
  link: string;
  expiration: number;
  mode: SSOLinkMode;
  linkFormatted?: string;

  constructor(ssoLink: SSOLink) {
    this.host = ssoLink?.host;
    this.link = ssoLink?.link;
    this.mode = ssoLink?.mode ?? SSOLinkMode.PREVIEW;
    this.expiration = ssoLink?.expiration;
  }
}

export enum SSOLinkMode {
  NORMAL = 'normal',
  PREVIEW = 'preview', // careful: also used in sas-scorm
  STANDALONE = 'standalone',
  DEV = 'dev',
}

export type SSOLinkFormatted = Required<SSOLink>;
